import { render, staticRenderFns } from "./GenericPlayer.vue?vue&type=template&id=26f7dbf4&"
import script from "./GenericPlayer.vue?vue&type=script&lang=js&"
export * from "./GenericPlayer.vue?vue&type=script&lang=js&"
import style0 from "./GenericPlayer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VFlex,VIcon,VTooltip})


/* hot reload */
if (module.hot) {
  var api = require("/Users/finnkelly/Code/Go Remote/remote-chat-finn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('26f7dbf4')) {
      api.createRecord('26f7dbf4', component.options)
    } else {
      api.reload('26f7dbf4', component.options)
    }
    module.hot.accept("./GenericPlayer.vue?vue&type=template&id=26f7dbf4&", function () {
      api.rerender('26f7dbf4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/GroupTeams/Common/Player/GenericPlayer.vue"
export default component.exports